export type OfferingDocumentId = OfferingDocument['id'];

export enum OfferingDocumentFormat {
  PDF = 'PDF',
  URL = 'URL',
}

export interface OfferingDocumentBase {
  id: number;
  ncId: string;
  offeringId: number;
  ncOfferingId: string;
  type: OfferingDocumentType;
  createdAt: Date;
  active: boolean;
  format: OfferingDocumentFormat;
  year: number | null;
}

export interface OfferingFileDocument extends OfferingDocumentBase {
  fileName?: string;
  format: OfferingDocumentFormat.PDF;
}

export interface OfferingUrlDocument extends OfferingDocumentBase {
  fileUrl: string;
  format: OfferingDocumentFormat.URL;
}

export type OfferingDocument = OfferingFileDocument | OfferingUrlDocument;

export enum OfferingDocumentType {
  OFFERING_CIRCULAR = 'OFFERING_CIRCULAR',
  RISK_FACTORS = 'RISK_FACTORS',
  SERIES_OVERVIEW = 'SERIES_OVERVIEW',
  USE_OF_PROCEEDS = 'USE_OF_PROCEEDS',
  FORM_1SA = 'FORM_1SA',
  FORM_1K = 'FORM_1K',
}

export interface OfferingDocumentUploadRequest {
  offeringId: number;
  type: OfferingDocumentType;
  format: OfferingDocumentFormat;
  file?: File;
  fileUrl?: string;
}
